import { View } from "@react-pdf/renderer";
import {

  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeAward } from "lib/redux/types";
import {
  ResumePDFDescriptionWithWhiteFont,
  TemplateNineteenPDFSection,
  TemplateNineteenSectionWithSubsections,
  ResumePDFDescription,
} from "./common";

export const Award = ({
  heading,
  awards,
  themeColor,
  isPDF,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  awards: ResumeAward[];
  themeColor: string;
  isPDF: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateNineteenSectionWithSubsections themeColor={themeColor} heading={heading}>
      {awards.map(({ award, issuer, descriptions }, idx) => (
        <View key={idx} wrap={false}>
          <View
            style={{
              ...styles.flexRowBetween,
              marginTop: spacing["0.5"],
            }}
          >
            <View
              style={{
                ...styles.flexRow,
                gap: spacing["2"],
              }}
            >
              <ResumePDFText bold={true}>{award}</ResumePDFText>
              <ResumePDFText >{issuer}</ResumePDFText>
            </View>
          </View>
          <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
            <ResumePDFDescription
              items={descriptions}
              enableHighlight={enableHighlight}
              enableMistakeHighlight={enableMistakeHighlight}
            />
          </View>
        </View>
      ))}
    </TemplateNineteenSectionWithSubsections>
  );
};
